var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"image"}},[_c('img',{attrs:{"src":require("../assets/construct_dex.png"),"height":"350px"}})])
}]

export { render, staticRenderFns }